<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="所属制度" prop="system_name">
              <Input disabled="disabled" class="perW60" v-model="infoData.system_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="细项标题" prop="title">
              <Input disabled="disabled" class="perW60" v-model="infoData.title"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="细项内容" prop="content">
              <div style="border: 1px solid #e9e9e9;border-radius: 10px;padding: 10px;">
                <div v-html="infoData.content"></div>
              </div>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="制度附件" prop="attachments">
              <fileUploader ref="qualitySystemItemsAttachments" :disabled="true" :showTip="true" :maxFiles="3" :allowedFormats="['pdf']"/>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="排序" prop="sort_order">
              <Input disabled="disabled" class="perW20" v-model="infoData.sort_order"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="是否有效" prop="is_active_msg">
              <Input disabled="disabled" class="perW30" v-model="infoData.is_active_msg"></Input>
            </FormItem>
          </Col>

        </Row>

      </Form>
    </card>

  </div>
</template>
<script>
import {qualitySystemItemsInfoApi} from '@/api/processing/quality/qualitySystemItems'
import fileUploader from "_c/fileUploader";
import {fileFormat} from "_c/common/fileFormat";

export default {
  name: 'qualitySystemItemsInfo',
  components: {fileUploader},
  data() {
    return {
      infoData: {
        system_id: 0,
        system_name: '',
        title: '',
        content: '',
        attachments: [],
        sort_order: 0,
        is_active_msg: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadInfoData(this.$route.params.id)
    }
  },
  methods: {
    // 加载数据
    loadInfoData(id) {
      qualitySystemItemsInfoApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

        // 附件多文件赋值
        if (this.infoData.attachments) {
          this.$refs.qualitySystemItemsAttachments.uploadedFiles = [];
          this.infoData.attachments.forEach(item => {
            this.$refs.qualitySystemItemsAttachments.uploadedFiles.push(fileFormat(item))
          })
        }

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },


  }
}
</script>
